import { render, staticRenderFns } from "./ContratacaoAnexos.vue?vue&type=template&id=e0c3679e"
import script from "./ContratacaoAnexos.vue?vue&type=script&lang=js"
export * from "./ContratacaoAnexos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports